import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { DISTRIBUTION_JOBS_API } from "./apiRoutes";
interface UseGetDistributionJobsListProps {
  communityId: string;
  year: string;
  frequency: string;
  type: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getDistributionJobs = async (communityId: string, year: string, type: string, frequency: string) =>
  await axiosAuth.get(`${DISTRIBUTION_JOBS_API(communityId)}/year/${year}/type/${type}/frequency/${frequency}`);

const useGetDistributionJobsList = ({
  queryParams,
  communityId,
  year,
  frequency,
  type
}: UseGetDistributionJobsListProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["distribution-jobs-list", communityId, year, type, frequency],
    queryFn: () => getDistributionJobs(communityId, year, type, frequency),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!communityId || queryParams?.enabled,
    ...queryParams,
  });
};

export default useGetDistributionJobsList;
